import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import { RootState } from "@/store/store";
import { setIseditAppointment } from "@/store/ui/ui";
import {
    resetNewAppointmentData,
    resetExistAppointmentData,
} from "@/store/appointments/appointmentsSlice";

import "./AppointmentsHeader.scss";
import Title from "@/shared/components/Title/Title";
import ReverseButton from "@/shared/components/ReverseButton/ReverseButton";

export default function AppointmentsHeader() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );

    useEffect(() => {
        return () => {
            dispatch(resetNewAppointmentData());
            dispatch(resetExistAppointmentData());
            dispatch(setIseditAppointment(false));
        };
    }, [dispatch]);

    return (
        <header className='appointmen_header header_in_content_component'>
            <ReverseButton
                onClick={() => {
                    navigate("/schedule");
                }}
            />
            <Title
                tag='h2'
                text={`${
                    isEditAppointment ? "Редагувати " : "Додати "
                } запис на прийом`}
            />
        </header>
    );
}
